import { drawingStore } from "../store";

export const getEditableDrawing = () => {
  const selectors = drawingStore.reduxStore?.selectors;
  const state = drawingStore.reduxStore?.store?.getState();
  if (!selectors || !state) return;

  return selectors.getEditableDrawing(state as never);
};
